/* global gapi */
import React from 'react';
import PropTypes from 'prop-types';
import { attachScript } from '../../../../../common/utils/attach-script';
import { AccessibleSocialButton } from './accessible-social-button';
const LIBRARY_URL = 'https://apis.google.com/js/platform.js';
export class YoutubeButton extends React.Component {
    constructor() {
        super(...arguments);
        this.init = (containerNode) => {
            gapi.ytsubscribe.render(containerNode, {
                channelid: this.props.cardData.id,
                count: 'hidden',
            });
            return new Promise((resolve) => {
                setTimeout(resolve);
            });
        };
    }
    attachScript() {
        if (window.gapi) {
            return Promise.resolve();
        }
        return attachScript(LIBRARY_URL);
    }
    render() {
        const { isAccessible, youtubeButtonTitle } = this.props;
        return (React.createElement(AccessibleSocialButton, { isAccessible: isAccessible, attachScript: this.attachScript, title: youtubeButtonTitle, initButton: this.init }));
    }
}
YoutubeButton.propTypes = {
    cardData: PropTypes.object,
    isAccessible: PropTypes.bool,
    youtubeButtonTitle: PropTypes.string,
};
//# sourceMappingURL=youtube.js.map